<div class="row">
    <div class="col-sm-6">
        <div class="custom-checkbox" title="Search All filters">
            <label class="checkbox-label font-normal">
                <input type="checkbox" [(ngModel)]="all" (change)="candidateInvitedStatusFilter($event,'all')" />
                <span class="checkmark" style="top: -5px"></span>
                <p class="label-ppp"> All</p>
            </label>
        </div>
    </div>

    <div *ngIf="candidateInvitedStatusList?.length > 0">
      <form [formGroup]="candidateInvitedFilterForm">
          <div *ngFor="let item of candidateInvitedStatusList;">
              <div class="col-sm-6">
                  <div class="custom-checkbox" title="Search {{item.value | titlecase}} filters">
                      <label class="checkbox-label font-normal">
                          <input type="checkbox" formControlName="{{item.itemId}}"
                              (change)="candidateInvitedStatusFilter($event,item.itemId)" />
                          <span class="checkmark" style="top: -5px"></span>
                          <!-- <p class="label-ppp"> {{item | titlecase}}</p> -->
                          <p *ngIf="item == 'INITIATED' " class="label-ppp">Invited </p>
                          <p *ngIf="item == 'ACCEPTED' " class="label-ppp">Applied </p>
                          <p *ngIf="item == 'REJECTED' " class="label-ppp">Rejected </p>
                          <p *ngIf="
                          item != 'ACCEPTED'
                          && item != 'INITIATED'
                          && item != 'REJECTED'" class="label-ppp"> {{item.value | titlecase}}</p>
                      </label>
                  </div>
              </div>
          </div>
      </form>
    </div>
</div>
